/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon24Solid = forwardRef('ArrowDUturnLeftUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M.806 8.724a1.5 1.5 0 0 0 2.188 2.052L6 7.57v5.93a8.5 8.5 0 1 0 17 0v-6a1.5 1.5 0 0 0-3 0v6a5.5 5.5 0 1 1-11 0V7.517l3.056 3.259a1.5 1.5 0 0 0 2.188-2.052l-4.53-4.833a3 3 0 0 0-4.378 0L.806 8.724Z" })));
});
